export default __webpack_public_path__ + "images/094423a871742c6a0d2598199fd106e9.svg";